import { groq } from 'next-sanity';
import { z } from 'zod';

import { basicText, SanityBasicText } from './basicText';
import { form, SanityForm } from './form';
import { formConfirmation, SanityFormConfirmation } from './formConfirmation';
import { link, SanityLink } from './link';

export const SanityRailsFormLanding = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('railsFormLanding'),
  _key: z.string(),
  theme: z.enum(['purple', 'charcoal', 'white', 'light', 'dark', 'black']),
  headline: z.string(),
  bodyCopy: z.string(),
  ctaMode: z.enum(['standardForm', 'redirectForm']),
  form: SanityForm.optional().nullable(),
  formConfirmation: SanityFormConfirmation.optional().nullable(),
  formFunnel: z.enum(['contact', 'rails']).optional().nullable(),
  primaryButtonLabel: z.string().optional().nullable(),
  emailPlaceholder: z.string().optional().nullable(),
  secondaryButton: SanityLink.optional().nullable(),
  trialText: z.string().optional().nullable(),
  legalText: SanityBasicText.optional().nullable(),
  mascot: z
    .enum([
      'none',
      'peek-teal-ul-then-lime-lr',
      'peek-lime-lr',
      'peek-purple-ll',
      'bounce-teal-bottom-to-cta',
      'roll-purple-bottom',
      'peek-purple-ul-then-teal-lc',
    ])
    .optional()
    .nullable(),
});
export type SanityRailsFormLanding = z.infer<typeof SanityRailsFormLanding>;

export const railsFormLanding = groq`{
  "theme": coalesce(theme, "charcoal"),
  headline,
  bodyCopy,
  // Existing modules predate ctaMode — keep the Rails waitlist email capture.
  "ctaMode": coalesce(ctaMode, "redirectForm"),
  form -> ${form},
  formConfirmation ${formConfirmation},
  "formFunnel": coalesce(formFunnel, "rails"),
  "primaryButtonLabel": coalesce(primaryButtonLabel, "Apply for Waitlist"),
  emailPlaceholder,
  secondaryButton[0] ${link},
  trialText,
  legalText[] ${basicText},
  'mascot': coalesce(mascot, 'none'),
}`;
